/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {stopTimecard} from '../api'

export const useMutationStopTimecard = createReactQueryMutationHook('stopTimecard', stopTimecard)
